// import { Outlet } from "react-router-dom";
// import AdminSidebar from "./AdminSidebar";
// import '../assets/css/admincustom.css';

// function AdminBase() {

//   return (
//     <div className="admin-container container-fluid p-0 m-0">
//       <AdminSidebar />
//       <div className="admin-content">
//         <Outlet />
//       </div>
//     </div>
//   );
// }
// export default AdminBase;
import { Outlet } from "react-router-dom";
import AdminSidebar from "./AdminSidebar";
import '../assets/css/admincustom.css';

function AdminBase() {

  return (
    <div className="admin-container container-fluid p-0 m-0">
      <AdminSidebar/>
      <div className="admin-content">
        <Outlet />
      </div>
    </div>
  );
}

export default AdminBase;
